import React, { useState, useEffect } from "react";

const StickyCustomized = ({ children }) => {
  const [stickyTop, setStickyTop] = useState(0);
  const [stickyZIndex, setStickyZIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 18) {
        setStickyTop(80);
        setStickyZIndex(999);
      } else {
        setStickyTop(0);
        setStickyZIndex(0);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      style={{
        position: "sticky",
        top: `${stickyTop}px`,
        fontSize: "25px",
        zIndex: `${stickyZIndex}`,
      }}
    >
      {children}
    </div>
  );
};

export default StickyCustomized;
